'use strict';

export default function EntityClassRequest(entityClass, filter, top, dataQueryName) {
	Object.defineProperties(this, {
		entityClass: { value: entityClass, writable: true, enumerable: true },
		filter: { value: filter, writable: true, enumerable: true },
		top: { value: top ? top : 0, writable: true, enumerable: true },
		parent: { writable: true, enumerable: true },
		relationName: { writable: true, enumerable: true },
		exclude: { writable: true, enumerable: true },
		objectId: { writable: true, enumerable: true },
		archived: { writable: true, enumerable: true },
		dataQueryName: { value: dataQueryName, writable: true, enumerable: true },
	});
}
